import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.5px',
    color: theme.palette.labraText.tertiary,
  },
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  customFieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(1),
    width: '100%',
    gap: theme.spacing(4),
  },
  customFieldTitle: {
    paddingTop: '20px',
  },
  customField: {
    paddingTop: '12px',
  },
  row: {
    display: 'flex',
    padding: theme.spacing(4),
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1.1),
    alignSelf: 'stretch',
    borderRadius: '4px',
    border: `1px solid ${theme.palette.dividerV2.main}`,
  },
  icon: {
    color: theme.palette.labraIcon.main,
    cursor: 'pointer',
    objectFit: 'contain',
    position: 'absolute',
    right: 0,
    bottom: 0,
  },
  titleAndIcon: {
    width: '100%',
    display: 'flex',
    position: 'relative',
  },
  title: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.primary,
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '28px',
  },
  buttonSubText: {
    color: theme.palette.textField.main,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    paddingLeft: theme.spacing(2),
  },
  boldText: {
    fontWeight: 600,
  },
  noteTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
  },
  noteTitle: {
    fontWeight: 600,
  },
  disableTrash: {
    pointerEvents: 'none',
  },
  fullWidth: {
    width: '100%',
  },
}))
